import script from "./FormationAll.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormationAll.vue?vue&type=script&setup=true&lang=ts"

import "./FormationAll.vue?vue&type=style&index=0&id=c99addb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c99addb6"]])

export default __exports__